import { atom } from "recoil";

const modalAtom = atom({
    key: 'modal',
    default: null
})

export default modalAtom